module.exports = __webpack_public_path__ + "static/img/brand.4332947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/brand.jpg
// module id = pESs
// module chunks = 0